import { useEffect, useState } from "react";
import axios from "axios";
import { getValidAccessToken } from "../utils/authHotjar";

const SITE_ID = "5275584";

interface HeatmapData {
  id: number;
  name: string;
  url: string;
  status: string;
}

const fetchHeatmaps = async (): Promise<HeatmapData[] | null> => {
  try {
    const accessToken = await getValidAccessToken();
    if (!accessToken) {
      console.error("No access token available");
      return null;
    }

    const response = await axios.get<{ heatmaps: HeatmapData[] }>(
      `https://api.hotjar.com/v2/sites/${SITE_ID}/heatmaps`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data.heatmaps || [];
  } catch (error) {
    console.error("Error fetching Hotjar heatmaps:", error);
    return null;
  }
};

const HotjarHeatmaps: React.FC = () => {
  const [heatmaps, setHeatmaps] = useState<HeatmapData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getHeatmaps = async () => {
      setLoading(true);
      setError(null);

      const data = await fetchHeatmaps();
      if (data) {
        setHeatmaps(data);
      } else {
        setError("Failed to load heatmaps.");
      }

      setLoading(false);
    };

    getHeatmaps();
  }, []);

  return (
    <div>
      <h1>🔥 Hotjar Heatmaps</h1>

      {loading && <p>Loading heatmaps...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {!loading && heatmaps.length === 0 && <p>No heatmaps found.</p>}

      <ul>
        {heatmaps.map((map) => (
          <li key={map.id}>
            <strong>{map.name}</strong> -{" "}
            <a href={map.url} target="_blank" rel="noopener noreferrer">
              {map.url}
            </a>
            <span> ({map.status})</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HotjarHeatmaps;

